import React from "react";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import SignUpEmployeeContent from "./SignUpEmployeeContent";
import { siteKey } from "../../../configs/url";

const SignUpEmployee = () => {

  return (
    <React.Fragment>
      <GoogleReCaptchaProvider
        reCaptchaKey={siteKey}
        scriptProps={{
          async: false,
          defer: false,
          appendTo: "head",
          nonce: undefined,
        }}
      >
        <SignUpEmployeeContent />
      </GoogleReCaptchaProvider>
    </React.Fragment>
  );
};

export default SignUpEmployee;
